import VueVideoPlayer from "vue-video-player";
import Vue from "vue";
import "video.js/dist/video-js.css";

Vue.use(VueVideoPlayer);
